/*
    本地存储的工具js
*/

export default {
    // 存,修改
    set(key,value){
        return localStorage.setItem(key,value);
    },
    // 取
    get(key){
        return localStorage.getItem(key);
    },
    // 删一条
    remove(key){
        return localStorage.removeItem(key);
    },
    // 清空
    clear(){
        return localStorage.clear();
    }
}




// WEBPACK FOOTER //
// ./src/utils/local.js